<template>
  <div class="modal-body modal-primary">
      <h5 class="link-topic">
          Choose a CLA
          <br/>
          <span class="side-note">(please note that changing the CLA results in a new request to sign the CLA from the contributors!)</span>
      </h5>
      <div class="row">

          <div class="col-xs-12">
              <div style="margin-bottom: 5px;">Select from Gist</div>
              <div class="form-group has-feedback" style="margin-bottom: 10px;">
                  <el-select v-model="selected.url" placeholder="请选择" style="width: 100%">
                    <el-option v-for="(option, index) in gists" :key="index" :label="option.name" :value="option.url">
                        <span v-if="option.name">{{option.name}}</span>
                    </el-option>
                  </el-select>
              </div>
              <div style="margin-bottom:10px">- or -</div>
              <div style="margin-bottom: 5px;">Paste a URL from a Gist</div>
              <input id="gitstUrl" :disabled="selected.gist.url" class="form-control" v-model="selected.gist.url" placeholder="https://gist.github.com/<your cla gist id>">
              <div style="margin-bottom: 15px; margin-top: 15px;">
                  <input id="sharedGist" type="checkbox" v-model="selected.item.sharedGist" :disabled="selected.gist && !selected.gist.url">&nbsp;Share the Gist &nbsp;
                  <span class="clickable" @click="innerVisible = true" style="font-size:12px; text-decoration:underline">(want to share?)</span>
              </div>
          </div>
      </div>

      <div v-for="(error, index) in errorMsg" :key="index" class="alert alert-danger col-xs-12" role="alert" v-show="errorMsg.length > 0">
          <span class="fa fa-warning" aria-hidden="true"></span>
          <span class="sr-only">Error:</span> {{ error }}
      </div>

      <div slot="footer" class="dialog-footer" style="text-align:right">
        <button class="btn btn-cancel" @click="cancel()" style="width:80px; margin-top:5px">Cancel</button>
        <button class="btn btn-success" :disabled="!selected.gist" @click="ok" style="width:80px">Save</button>
      </div>
      <el-dialog width="30%" :visible.sync="innerVisible" append-to-body>
        <div class="modal-body modal-primary">
            <div class="free-space">
                <h4>What happens if I choose to share the gist with multiple repos or orgs?</h4>
                <div>
                    Contributors will simply need to sign only once for any of the repos or orgs linked with the same shared gist.
                </div>
            </div>
            <div class="free-space">
                <h4>Are previous CLA signatures still valid after I choose to share the gist with multiple repos or orgs?</h4>
                <div>
                    Yes, but the scope of the previous signatures are still limited to the previous repo or org.
                </div>
            </div>
            <div class="free-space">
                <h4>What happens if I uncheck the box and choose NOT to share the gist any more?</h4>
                <div>
                    Previous contributors that have signed the shared gist will have to sign again.
                </div>
            </div>
        </div>
      </el-dialog>
  </div> 
</template>

<script>
import vSelect from 'vue-select'
import {updateRepoOrOrg} from '@/api/home'
export default {
  props:{
    gists:{},
    item: {},
    gist: {}
  },
  data () {
    return {
      innerVisible:false,
      selected:{
        item:{
          sharedGist: false
        }, 
        gist:{
          name:'',
          url:''
        },
        name:''
      },
      linkedItem: this.item,
      errorMsg: []
    };
  },
  components:{vSelect},
  created() {
    this.initGist()
  },
  methods: {
    initGist() {
        this.selected.gist = this.gists.find((g) =>{
            return g.url === this.item.gist;
        }) || this.gist;
    },
    ok() {
        this.selected.item.gist = this.selected.gist.url;
        this.updateLink(this.selected.item)
    },
    updateLink(item) {
        let type = 'repo' 
        let newItem = this.createNewItem(item, type);
        updateRepoOrOrg(type, newItem).then((res) =>{
            this.$emit("close")
        }).catch((err) =>{
            this.errorMsg.push(err);
        })
    },
    createNewItem(item, type) {
        let newItem = {
            gist: item.gist,
            sharedGist: item.sharedGist
        };
        newItem.repoId = this.item.repoId || this.item.id;
        newItem.repo = this.item.repo || this.item.name;
        newItem.owner = this.item.owner.login || this.item.owner;

        return newItem;
    },
    cancel() {
        this.$emit('close')
    }
  }
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// src/javascript/home/components/modal/editLinkedItem.vue